import React from 'react';
import BasicMenu from './BasicMenu';
import { useAcesso } from '../hooks/useAcesso';

interface ProtectedBasicMenuProps {
  tela: string;
  onDelete: () => void;
  onEdit: () => void;
  onViewMore?: () => void;
  isWhite?: boolean;
  isArchived?: boolean;
  fontSize?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  deleteConfirmTitle?: string;
  deleteItemName?: string;
  deleteConfirmMessage?: string;
  deleteButtonText?: string;
  cancelButtonText?: string;
}

const ProtectedBasicMenu: React.FC<ProtectedBasicMenuProps> = ({ 
  tela, 
  onEdit, 
  onDelete, 
  ...props 
}) => {
  const { temAcesso } = useAcesso();

  // Criar versões protegidas das funções
  const protectedEdit = temAcesso(tela, 'alteracao') ? onEdit : () => {};
  const protectedDelete = temAcesso(tela, 'alteracao') ? onDelete : () => {};

  return (
    <BasicMenu
      {...props}
      onEdit={protectedEdit}
      onDelete={protectedDelete}
      disabled={!temAcesso(tela, 'visualizacao')}
    />
  );
};

export default ProtectedBasicMenu;